import { IconProps } from '@/types/icon';

export function IconeRemover({ size, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="remover"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M12.6666 8.66665H3.33331V7.33331H12.6666V8.66665Z"
        fill="currentColor"
      />
    </svg>
  );
}
